import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgMenu(props: RootSvgProps) {
  return (
    <RootSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line x1="5" y1="5.5" x2="20" y2="5.5" stroke="black" />
      <line x1="5" y1="11.5" x2="20" y2="11.5" stroke="black" />
      <line x1="5" y1="17.5" x2="20" y2="17.5" stroke="black" />
    </RootSvg>
  );
}
